import api from './api'

const accountService = {
  /**
   * Get current account information
   */
  getAccount: async () => {
    const response = await api.get('/accounts/me')
    return response.data
  },

  /**
   * Update current account
   */
  updateAccount: async (data) => {
    const response = await api.put('/accounts/me', data)
    return response.data
  },

  /**
   * Delete current account
   */
  deleteAccount: async () => {
    const response = await api.delete('/accounts/me')
    return response.data
  },

  /**
   * Change password
   */
  changePassword: async (currentPassword, newPassword) => {
    const response = await api.put('/auth/password/change', {
      current_password: currentPassword,
      new_password: newPassword
    })
    return response.data
  },
}

export default accountService
